// This has been turned into a module because I need it in two different
// locations. Once to supply default fees to redux, and once to supply to
// the actual LemonLaw dropdown menu.
import getPipeValue from './getPipeValue';

function getLemonLawDropdownOptions(options) {
  const { selectedVehicleValue } = options;
  const { disableLemon, mcoTitle } = options.selectedTitleVariables;
  const t2 = Number(options.selectedTitleVariables.t2);

  let r16 = 0;
  if (selectedVehicleValue) {
    r16 = Number(getPipeValue(selectedVehicleValue, 'r16'));
  }

  // Just for debugging. Remove after fully tested.
  // console.log('LemonLaw, getOptions', { r16, t2, disableLemon });

  const disabledLemonLaw = [
    ['No Lemon Law Fee Required', 0],
  ];

  const enabledLemonLaw = [
    ['$2.00 Lemon Law Fee unless exempt', 2],
    ['Lemon Law EXEMPT', 0],
  ];

  let dropdown = disabledLemonLaw;

  if (typeof disableLemon === 'boolean') {
    dropdown = disableLemon ? disabledLemonLaw : enabledLemonLaw;
  }

  // These are the options are they appear in the PDF
  // when you choose an option from `MCO Manufacturer`
  if (mcoTitle) {
    if (r16 === t2 || r16 === 0) {
      if (t2 === 4) {
        dropdown = disabledLemonLaw;
      }

      if (t2 === 5) {
        dropdown = disabledLemonLaw;
      }

      if (t2 === 7) {
        dropdown = disabledLemonLaw;
      }
    }
  }
  return dropdown;
}

export default getLemonLawDropdownOptions;



// WEBPACK FOOTER //
// ./src/modules/getLemonLawDropdownOptions.js